<template>
  <v-dialog @keydown.esc="isOpen=false" v-model="isOpen" persistent max-width="400px">
    <template v-if="btn" v-slot:activator="{ on }">
      <v-tooltip left>
        <template v-slot:activator="{ on }">
          <v-btn
            v-on="on"
            fab
            color="info"
            x-small
            depressed
            @click="isOpen = true"
          >
            <v-icon
              small
            >
              mdi-silverware-fork-knife
            </v-icon>
          </v-btn>
        </template>
        <span>{{ item.subrecipe ? 'Listar como producto' : 'Enviar al menú' }}</span>
      </v-tooltip>
    </template>
    <v-card>
      <v-card-title>
        <span class="headline">{{ item.subrecipe ? `Publicar ${item.name} como producto` : `Enviar ${item.name} al menú` }}</span>
      </v-card-title>
      <v-card-text>
        <v-form ref="attachRecipe" v-model="form.valid">
          <v-container grid-list-xl>
            <v-layout wrap>
              <v-flex xs12 md12>
                <v-text-field
                  v-if="!form.data.subrecipe"
                  :label="$t('recipes.labels.internalId')"
                  v-model="form.data.internalId"
                  :rules="validation.internalId"
                >
                </v-text-field>
                <v-text-field
                  :label="$t('recipes.labels.name')"
                  v-model="form.data.name"
                  :rules="validation.name"
                  required>
                </v-text-field>
                <v-text-field
                  v-if="!form.data.subrecipe"
                  :label="$t('recipes.labels.price')"
                  v-model="form.data.price"
                  prefix="$"
                  :suffix="`Costo: $${(item.cost || 0).toFixed(2)}`"
                  :rules="validation.price"
                >
                </v-text-field>
                <v-text-field
                  v-if="form.data.subrecipe"
                  :label="$t('recipes.labels.production')"
                  v-model.number="form.data.production"
                  :rules="validation.production"
                  required>
                </v-text-field>
              </v-flex>
              <v-flex
                v-if="!form.data.subrecipe"
                xs12 md12 class="d-flex"
              >
                <NewSection />
                <v-select
                  :label="$t('recipes.labels.section')"
                  v-model="form.data.section"
                  :items="sections"
                  :rules="validation.section"
                  item-text="name"
                  item-value="_id"
                  required
                />
              </v-flex>
              <v-flex
                xs12
                md12
                class="d-flex"
                v-if="form.data.subrecipe"
              >
                <v-select
                  :label="$t('recipes.labels.unitStock')"
                  v-model="form.data.unitStock"
                  :items="units"
                  :rules="validation.unitStock"
                  item-text="name"
                  item-value="id"
                />
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          class="mr-4"
          outlined
          rounded
          small
          depressed
          @click="closeDialog">
          {{ $t('recipes.close') }}
        </v-btn>
        <v-btn
          color="primary"
          class="mr-4"
          rounded
          small
          depressed
          @click="submit">
          {{ $t('recipes.confirm') }}
        </v-btn>
      </v-card-actions>
    </v-card>

    <v-overlay :value="overlay" z-index="99999">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-dialog>
</template>

<script>
import NewSection from '@/components/modals/NewSection'
import { cloneDeep } from 'lodash'
import { required, string, isnil, number, numeric, isnull, object } from 'vue-mc/validation'

export default {
  props: {
    item: {
      type: Object,
      required: true
    },
    btn: {
      type: Boolean,
      default: true
    }
  },
  components: {
    NewSection
  },
  data () {
    return {
      overlay: false,
      isOpen: false,
      form: {
        valid: false,
        data: {
          internalId: null,
          name: null,
          price: null,
          section: null,
          subrecipe: false,
          status: 'attached'
        }
      },
      validation: {
        internalId: [required.and(string)],
        name: [required.and(string)],
        description: [this.item.subrecipe ? string.or(isnil) : isnil],
        price: [!this.item.subrecipe ? required.and(number.or(numeric)) : isnil.or(number.or(numeric))],
        production: [number],
        section: [!this.item.subrecipe ? required.and(string) : isnil.or(object)],
        unitStock: [isnull.or(string)]
      }
    }
  },
  computed: {
    units: function () {
      const availableUnitCodes = ['kg', 'l', 'pz']
      return this.$store.state.login.units.data.filter(unit => availableUnitCodes.includes(unit.code)) || []
    },
    sections: function () {
      return (this.$store.state.currentRestaurant.sections.data || [])
        .filter(section => section.area && (section.area === this.$store.state.area._id || section.area._id === this.$store.state.area._id))
    }
  },
  watch: {
    isOpen (val) {
      if (val) {
        this.resetRecipeForm()
      }
    }
  },
  methods: {
    submit: async function () {
      this.$refs.attachRecipe.validate()

      if (this.form.valid) {
        this.overlay = true
        try {
          const payload = cloneDeep(this.form.data)
          await this.$api.put(`/v1/recipes/${this.item.uuid}`, payload)
          await this.$api.post(`/v1/recipes/${this.item.uuid}/status/attached?section=${payload.section}`, payload)
          this.closeDialog()
        } catch (error) {
          this.$toasted.show(error.message, { duration: 3000 })
        }
        this.overlay = false
      }
    },
    resetRecipeForm () {
      this.form.data = {
        uuid: this.item.uuid,
        internalId: this.item.internalId,
        name: this.item.name,
        price: this.item.price,
        status: 'attached',
        area: this.item.area,
        section: (this.item.section || {}).id,
        subrecipe: this.item.subrecipe,
        production: this.item.subrecipe
          ? this.item.production
          : 0,
        unitStock: this.item.subrecipe
          ? (this.item.unitStock && this.item.unitStock.id)
            ? this.item.unitStock.id
            : this.item.unitStock
          : null
      }
    },
    closeDialog () {
      this.isOpen = false
      this.$emit('close', false)
    },
    open () {
      this.isOpen = true
    }
  }
}
</script>
